import { Suspense } from 'react'

export const LayoutPage = ({
  children,
  browserTitle,
  postfix = ' - Sevalla',
  fallback,
}: {
  children: React.ReactNode
  browserTitle: string
  postfix?: string
  fallback: React.ReactNode
}) => {
  return (
    <Suspense fallback={fallback}>
      <title>{browserTitle + postfix}</title>
      {children}
    </Suspense>
  )
}
